/**
 * @description 優惠活動 類型用
 */
export enum PromotionType {
  /** 全部 */
  All = 'All',
  /** 活動列表 */
  Promotion = 'PROMOTION',
  /** 得獎公告 */
  PrizeWinner = 'PRIZE_WINNER',
  /** 加值服務 */
  ValueAdd = 'VALUE_ADD'
}

/**
 * @description 優惠活動列表 Section
 */
export enum PromotionSectionType {
  /** 活動列表 */
  Promotion = 'PROMOTION',
  /** 得獎公告 */
  PrizeWinner = 'PRIZE_WINNER',
  /** 加值服務 */
  ValueAdd = 'VALUE_ADD'
}
